// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".right[data-v-5b9461a7] {\n  margin-left: 0.166667rem;\n  width: 1.015625rem;\n}\n.right div[data-v-5b9461a7] {\n  margin-bottom: 0.09375rem;\n}\n.right img[data-v-5b9461a7] {\n  margin-top: 0.005208rem;\n  width: 100%;\n}\n.right div[data-v-5b9461a7]:nth-child(1) {\n  width: 99%;\n  border: 0.005208rem solid #e7e7e7;\n}", ""]);
// Exports
module.exports = exports;
